import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { StepByStepWizardModule } from '@app/shared/step-by-step-wizard';
import { IconComponent } from '@shared/icon/icon.component';

import { SpinnersModule } from 'lingo2-forms';
import { ClickOutsideModule } from 'ng-click-outside';
import { OnUiButtonModule, OnUiCheckboxModule, OnUiPopoverModule } from 'onclass-ui';

import { PaymentOrderComponent } from '../payment-order/payment-order.component';
import { PaymentWidgetMerchantProcessingModule } from './payment-widget-merchant-processing/payment-widget-merchant-processing.module';
import { PaymentWidgetPaymentMethodSelectorModule } from './payment-widget-payment-method-selector';
import { PaymentWidgetComponent } from './payment-widget.component';
import { PaymentWidgetService } from './payment-widget.service';

// TODO Convert to DynamicModule with config

@NgModule({
  declarations: [PaymentWidgetComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    OnUiButtonModule,

    SpinnersModule,
    OnUiCheckboxModule,
    StepByStepWizardModule,
    PaymentWidgetPaymentMethodSelectorModule,
    PaymentWidgetMerchantProcessingModule,
    OnUiPopoverModule,
    ClickOutsideModule,
    IconComponent,
    PaymentOrderComponent,
  ],
  providers: [PaymentWidgetService],
  exports: [PaymentWidgetComponent],
})
export class PaymentWidgetModule {}
